export function getUrlVars() {
  const vars = {};
  const parts = window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    (m, key, value) => {
      return (vars[key] = value);
    }
  );
  return vars;
}
